import React, { useEffect, useState } from 'react';
import './Payrollpage.css'; // Import your CSS file for styling
import { useNavigate } from 'react-router-dom';

export default function Payrollpage() {
  const [payroll, setPayroll] = useState([]);

  const nav = useNavigate()

  useEffect(() => {
    fetchPayrollDetails();
  }, []);

  async function fetchPayrollDetails() {
    try {
      const res = await fetch("https://payrole.onrender.com/PayrollRecords", {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      const payrollData = await res.json();
      setPayroll(payrollData);
    } catch (error) {
      console.error("Error fetching payroll details:", error);
    }
  }


    // Helper function to format date
    function formatDate(dateStr) {
      const date = new Date(dateStr);
      const monthNames = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "October", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();
      const hoursElapsed = (Date.now() - date.getTime()) / (1000 * 60 * 60); // Calculate hours elapsed
      if (hoursElapsed < 10) {
        const hoursElapsedRound = Math.floor(hoursElapsed);
        if (hoursElapsedRound < 1) {
          const minutesElapsed = Math.floor(hoursElapsed * 60); // Calculate minutes elapsed
          if (minutesElapsed < 1) {
            const secondsElapsed = Math.floor(hoursElapsed * 60 * 60); // Calculate seconds elapsed
            return `${secondsElapsed} seconds ago`;
          } else {
            return `${minutesElapsed} minutes ago`;
          }
        } else {
          return `${hoursElapsedRound} hour ago`;
        }
      } else {
        const time = date.toLocaleTimeString();
        return ` ${day} ,${month}  ${year}`;
      }
    }
  

  return (
    <div className="payroll-container">
      <div className="table-responsive">
        <table className="payroll-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Employee ID</th>
              <th>Department ID</th>
              <th>Net Pay</th>
              <th>Payroll Date</th>
            </tr>
          </thead>
          <tbody>
            {payroll.map((employee) => (
              <tr key={employee.EmployeeID} onClick={()=>{



nav(`/payroll/${employee.EmployeeID}`)




              }}  >
                <td>{employee.FirstName} {employee.LastName}</td>
                <td>{employee.EmployeeID}</td>
                <td>{employee.DepartmentID}</td>
                <td>{employee.NetPay}</td>
                <td>  {formatDate(employee.PayrollDate)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
